import React from "react";
import { FormattedDate } from "react-intl";
import { Table, Row, Col } from "reactstrap";

import CashActivity from "./CashActivity";
import ProductActivity from "./ProductActivity";
import style from "./Grid.module.scss";
import { UserType } from "../../../utils/Helper";
import { CustomFormInput } from "../../..";
import { FormattedNumber } from "../../FormattedNumber/FormattedNumber";
import { useEffect } from "react";

const JournalEntry = ({ journalEntry, userType, opsViewAccountName}) => {

  const debits = [...(journalEntry.Level1 || [])];
  let splitIndex = debits.length;
  debits.forEach((a, i) => {
    if (a.Credit && i < splitIndex) {
      splitIndex = i;
    }
  });
  const credits = debits.splice(splitIndex);
  return (
    <React.Fragment>
      <Row>
        <Col xs={6} md={4} lg={3}>
          <CustomFormInput label="Status">{journalEntry.JournalEntryStatus}</CustomFormInput>
        </Col>
      </Row>
      {(userType === UserType.BackOffice ||
        userType === UserType.Trader ||
        userType === UserType.MiddleOffice ||
        userType === UserType.Accounting ||
        userType === UserType.FundManager) && (
        <React.Fragment>
          <Row>
            <Col xs={6} md={4} lg={3}>
              <CustomFormInput label="Register Date">
                {journalEntry.JournalEntryRegisteredDate &&
                !journalEntry.JournalEntryRegisteredDate.includes("0000-00-00") ? (
                  <FormattedDate value={journalEntry.JournalEntryRegisteredDate} />
                ) : (
                  " - "
                )}
              </CustomFormInput>
            </Col>
            <Col xs={6} md={4} lg={3}>
              <CustomFormInput label="Payment Date">
                {journalEntry.JournalEntryPaymentDate &&
                !journalEntry.JournalEntryPaymentDate.includes("0000-00-00") ? (
                  <FormattedDate value={journalEntry.JournalEntryRegisteredDate} />
                ) : (
                  " - "
                )}
              </CustomFormInput>
            </Col>
          </Row>
          <ActivityTable items={debits} title="Debit" />
          <hr />
          <ActivityTable items={credits} title="Credit" />
          <hr />
        </React.Fragment>
      )}
      <CashActivity activity={journalEntry.CashActivity} opsViewAccountName={opsViewAccountName}/>
      <hr />
      <ProductActivity activity={journalEntry.ProductActivity} opsViewAccountName={opsViewAccountName}/>
    </React.Fragment>
  );
};

const ActivityTable = ({ items, title }) => (
  <div className={style.grid}>
    <Table responsive hover>
      <thead>
        <tr>
          <th>{title}</th>
          <th className="text-right">Amount</th>
        </tr>
      </thead>
      <tbody>
        {items.map((item) => (
          <tr key={item[title]}>
            <td>{item[title]}</td>
            <td className="text-right">
              <FormattedNumber value={item.Volume} dataTypeDecimalName="currency" /> {item.Currency}
            </td>
          </tr>
        ))}
        {items.length === 0 && (
          <tr>
            <td colSpan={8} style={{ textAlign: "center" }}>
              No {title}s
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  </div>
);

export default JournalEntry;
